import { themeColors } from "@/styles"

import { makeStyles } from "@/utils/makeStyles"

const useStyles = makeStyles(() => ({
	selectInternIcons: {
		"& .MuiAutocomplete-endAdornment": {
			right: 16
		},
		"& .MuiAutocomplete-popupIndicator": {
			color: themeColors.colors.system.gray[800]
		}
	},
	selectLoading: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		padding: 2
	}
}))

export default useStyles